const css = `
	@keyframes wm-show {
		from { transform: scale(0) translate(-50%, -50%); }
		to   { transform: scale(1) translate(-50%, -50%); }
	}
	@keyframes wm-rotate {
		0%   { transform: rotate(0deg); }
		70%  { transform: rotate(0deg); }
		80%  { transform: rotate(190deg); }
		90%  { transform: rotate(180deg); }
		100% { transform: rotate(180deg); }
	}
	@keyframes wm-path {
		0%   { stroke-dashoffset: 600px; opacity: 0.85; }
		55%  { stroke-dashoffset: 0px;   opacity: 0.85; }
		80%  { stroke-dashoffset: 0px;   opacity: 0.85; }
		95%  { stroke-dashoffset: 0px;   opacity: 0; }
		100% { stroke-dashoffset: 0px;   opacity: 0; }
	}
	@keyframes wm-circle {
		0%      { transform: translate(0px,   0px);  }
		5.55%   { transform: translate(0px,   84px); }
		11.1%   { transform: translate(0px,   42px); }
		16.65%  { transform: translate(57px,  42px); }
		22.2%   { transform: translate(57px,  -5px); }
		27.75%  { transform: translate(57px,  94px); }
		33.3%   { transform: translate(57px,  42px); }
		38.85%  { transform: translate(113px, 42px); }
		44.4%   { transform: translate(113px, 0px);  }
		50%     { transform: translate(113px, 84px); }
		100%    { transform: translate(113px, 84px); }
	}
	.wm-loader {
		transform: scale(0) translate(-50%, -50%);
		animation: wm-show 0.3s cubic-bezier(0, 0.75, 0.41, 1.05) forwards;
		position: absolute;
		top: 50%;
		left: 50%;
		width: 50px;
		transform-origin: top center;
	}
	.wm-loader svg {
		animation: wm-rotate 1.5s infinite;
		will-change: transform;
	}
	.wm-loader-path {
		fill: none;
		stroke: #fff;
		stroke-width: 23;
		stroke-linecap: round;
		stroke-linejoin: round;
		stroke-miterlimit: 10;
		stroke-dasharray: 600px;
		stroke-dashoffset: 600px;
		animation: wm-path 1.5s linear infinite;
	}
	.wm-loader-circle {
		fill: #fff;
		stroke: #ddd;
		stroke-width: 1px;
		animation: wm-circle 1.5s linear infinite;
		will-change: transform;
	}
`;

const WebmotorsLoader = () => (
	<div className="relative min-h-screen">
		<style>{css}</style>
		<div className="wm-loader">
			<svg viewBox="0 0 250 250" aria-label="Carregando...">
				<rect x="50" y="50" width="150" height="150" fill="#b6061e" />
				<path
					className="wm-loader-path"
					d="M68,83v84.3v-32.2c0-5.3,4.4-9.7,9.7-9.7l0,0h37.2l0,0c5.3,0,10-4.4,10-10v-0.3V77.4v58v37.1v-37.4
					c0-5.3,4.4-9.7,9.7-9.7l0,0h37.2l0,0c5.6,0,10-4.7,10-10l0,0V83c0,0,0,58.5,0,84.1"
				/>
				<path
					fill="#ec0928"
					d="M124.8,5.5C58.6,5.5,5.2,58.9,5.2,124.8s53.4,119.6,119.6,119.6c65.9,0,119.6-53.4,119.6-119.6
					C244.1,58.9,190.7,5.5,124.8,5.5z M191.3,166c0,5.6-4.7,10-10.3,10c-5.3-0.3-9.4-5-9.4-10.3v-25.6c0-2.8-2.5-5.3-5.3-5.3h-26.5
					c-2.8,0-5.3,2.5-5.3,5.3v31.9c0,5.6-4.7,10-10.3,10c-5.3-0.3-9.4-5-9.4-10.3v-31.2c0-2.8-2.5-5.3-5.3-5.3H83
					c-2.8,0-5.3,2.5-5.3,5.3v26.2c0,5.6-4.7,10-10.3,10c-5.3-0.3-9.4-5-9.4-10.3V83.6c0-5.6,4.7-10,10.3-10
					c5.3,0.3,9.4,5,9.4,10.3v25.6c0,2.8,2.5,5.3,5.3,5.3h26.5c2.8,0,5.3-2.5,5.3-5.3V78c0-5.6,4.7-10,10.3-10
					c5.3,0.3,9.4,5,9.4,10.3v31.2c0,2.8,2.5,5.3,5.3,5.3h26.5c2.8,0,5.3-2.5,5.3-5.3V83.9c0-5.3,4.1-10,9.4-10.3
					c5.6-0.3,10.3,4.4,10.3,10V166z"
				/>
				<circle className="wm-loader-circle" r="11" cx="67.8" cy="83.1" />
			</svg>
		</div>
	</div>
);

WebmotorsLoader.displayName = 'WebmotorsLoader';

export { WebmotorsLoader };
